import { styled } from '@styles/stitches';

export const VerticalContainer = styled('div', {
  width: '100vw',
  marginBottom: '$2',

  '@bp1': {
    width: '50vw',
    margin: '0 auto',
  },

  '@bp2': {
    width: '718px',
  },

  '& > *': {
    display: 'block',
    marginBottom: '$2',
  },
});
